module.exports = __webpack_public_path__ + "img/item5.f1725453.png";